// themes.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, Arial, sans-serif', // Set your default font
    allVariants: {
      margin: 0,
      padding: 0,
      lineHeight: 'normal', // Customize the line height, etc.
      // Add any other CSS overrides here
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          // Reset specific styles here
          color: 'inherit', // For example, reset the color
          fontSize: 'inherit',
          fontWeight: 'inherit',
          lineHeight: 'inherit',
          textTransform: 'none', // Override any default transformations
          margin: 0,
          padding: 0,
          // Add any other overrides you need
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280, // Set 1280px as the start of "desktop" (lg) breakpoint
      xl: 1920,
    },
  },
});

export default theme;
